import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Button,
  Stack,
  styled
} from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#f9fafb',
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  flexDirection: 'column',
  height: '1000px',
  backgroundImage: `url('/image.jpg')`,
  width: '95%',
  position: 'relative',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundSize: 'cover',
}));

const IframeWrapper = styled(Box)(({ device, height }) => ({
  position: 'relative',
  contain: 'content',
  transform: 'translateX(-50%)',
  overflow: 'hidden',
  overflowY: 'hidden',         
  overflowX: 'hidden',
  left: '50%',
  borderRadius: '8px',
  transition: 'height 0.3s ease',
  border: '0px solid blue',
  width: 'fit-content',
  minWidth: '800px',
  height: height,
  '&::-webkit-scrollbar': {
    display: 'none',  // For Chrome, Safari, and newer versions of Edge
  },
  '-ms-overflow-style': 'none',  // For Internet Explorer and Edge
  'scrollbarWidth': 'none',  // For Firefox
}));

// const IframeContainer = styled(Box)(({ device }) => ({
//   position: 'relative',
//   contain: 'content',
//   overflow: 'hidden'
//   // Remove the translateX if it's not needed for centering
// }));

const frameHeights = {
  initial: {
    desktop: '12%',
    mobile: '12%'
  },
  searching: {
    desktop: '90%',
    mobile: '90%'
  },
  chat: {
    desktop: '90%',
    mobile: '90%'
  }
};

const DemoSection = () => {
  const [device] = useState('desktop');
  const [demoState, setDemoState] = useState('initial');
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== "https://frontend-app-743663438976.australia-southeast1.run.app" && 
          event.origin !== "http://localhost:1000") return;
      
      const { type } = event.data;

      switch (type) {
        // case 'PREVENT_SCROLL': {
        //   // Store the current scroll position right when preventing scroll
        //   const scrollPosition = document.documentElement.scrollTop;
        //   // document.body.style.position = 'fixed';
        //   // document.body.style.top = `-${scrollPosition}px`;
        //   // document.body.style.width = '100%';
        //   // Store the scroll position as a data attribute
        //   document.body.setAttribute('data-scroll', scrollPosition);
        //   break;
        // }
        // case 'ALLOW_SCROLL': {
        //   // Retrieve the stored scroll position
        //   const scrollPosition = document.body.getAttribute('data-scroll');
        //   // document.body.style.position = '';
        //   // document.body.style.top = '';
        //   // document.body.style.width = '';
        //   // Restore scroll position using scrollTo
        //   window.scrollTo(0, parseInt(scrollPosition || '0'));
        //   break;
        // }
        case 'SEARCH_START':
          setDemoState('searching');
          break;
        case 'CHAT_OPEN':
          setDemoState('chat');
          break;
        case 'RESET':
          setDemoState('initial');
          break;
        default:
          break;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <Box 
      component="section" 
      id="demo"
      sx={{
        py: 8,
        bgcolor: 'white'
      }}
    >
      <Container>
        <Typography 
          variant="h3" 
          component="h2"
          align="center"
          sx={{
            color: '#0d9488',
            fontWeight: 700,
            mb: 2
          }}
        >
          Demo
        </Typography>
        
        <Typography 
          variant="h5" 
          align="center" 
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Experience Searchable in action on our demo site
        </Typography>

        <StyledPaper elevation={4} style={{ overflow: 'hidden' }}>
          <IframeWrapper 
            ref={iframeRef}
            component="iframe"
            device={device} 
            height={frameHeights[demoState][device]}
            src="http://localhost:1000/"
            title="Searchable Demo"
            style={{ overflow: 'hidden' }}
            scrolling="no"
          />
          {/* <IframeContainer device={device}>
            <Box
              component="iframe"
              ref={iframeRef}
              height={frameHeights[demoState][device]}
              src="http://localhost:1000/"
              title="Searchable Demo"
              sx={{
                border: 'none',
                width: '100%',
                overflow: 'hidden'
              }}
            />
          </IframeContainer> */}
        </StyledPaper>

        {/* <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          justifyContent="center"
          sx={{ mt: 4 }}
        >
          <Button
            variant="contained"
            sx={{
              bgcolor: '#0d9488',
              '&:hover': { bgcolor: 'rgba(13, 148, 136, 0.8)' }
            }}
          >
            Start Free Trial
          </Button>
          <Button
            variant="outlined"
            sx={{
              color: '#0d9488',
              borderColor: '#0d9488',
              '&:hover': {
                borderColor: 'rgba(13, 148, 136, 0.8)',
                bgcolor: 'rgba(13, 148, 136, 0.04)'
              }
            }}
          >
            View Documentation
          </Button>
        </Stack> */}
      </Container>
    </Box>
  );
};

export default DemoSection;